import React from "react";
import "./App.css";

const App = () => {
  return (
    <div className="container">
      <div className="resume-card">
        <div className="header">
          <div className="profile-section">
            <div className="profile-img">
              <img
                src="/CalebNoble.png"
                alt="Caleb Noble"
                className="headshot"
              />
            </div>
            <h1 className="name">Caleb Noble</h1>
            <p className="title">Aspiring Sports Marketing Professional</p>
            <div className="contact-info">
              <div className="contact-item">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                </svg>
                <a
                  href="mailto:cibble24@gmail.com"
                  style={{ color: "inherit", textDecoration: "none" }}
                >
                  cibble24@gmail.com
                </a>
              </div>
              <div className="contact-item">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                </svg>
                <a
                  href="tel:8144405829"
                  style={{ color: "inherit", textDecoration: "none" }}
                >
                  (814) 440-5829
                </a>
              </div>
              <div className="contact-item">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                </svg>
                <span>Erie, PA</span>
              </div>
            </div>
          </div>
        </div>

        <div className="content">
          <div className="section">
            <h2 className="section-title">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
              </svg>
              Professional Summary
            </h2>
            <div className="objective">
              Passionate sports enthusiast with hands-on experience in customer
              service, sales, and team collaboration. Combines deep sports
              knowledge with natural communication skills and creative
              problem-solving. Seeking to launch a career in sports marketing
              where I can connect with fans and help teams build lasting
              relationships with their communities.
            </div>
          </div>

          <div className="section">
            <h2 className="section-title">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M20 6h-2.18c.11-.31.18-.65.18-1a2.996 2.996 0 0 0-5.5-1.65l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z" />
              </svg>
              Professional Experience
            </h2>

            <div className="experience-item">
              <div className="job-header">
                <div>
                  <div className="job-title">
                    Customer Service & Sales Associate
                  </div>
                  <div className="company">Gordon's Meat Market</div>
                </div>
                <div className="dates">March 2021 – Present</div>
              </div>
              <div className="responsibilities">
                Build customer relationships through personalized service and
                product knowledge. Handle wholesale accounts, manage invoicing,
                and collaborate with team members in fast-paced environment.
                Developed strong sales and communication skills through daily
                customer interactions.
              </div>
            </div>

            <div className="experience-item">
              <div className="job-header">
                <div>
                  <div className="job-title">Grounds Crew Member</div>
                  <div className="company">Whispering Woods Golf Course</div>
                </div>
                <div className="dates">May 2024 – August 2024</div>
              </div>
              <div className="responsibilities">
                Maintained high-quality course conditions through attention to
                detail and teamwork. Worked early morning shifts requiring
                strong time management and dedication to excellence – qualities
                essential in sports operations.
              </div>
            </div>

            <div className="experience-item">
              <div className="job-header">
                <div>
                  <div className="job-title">Summer Camp Counselor</div>
                  <div className="company">
                    St. George School Summer Program
                  </div>
                </div>
                <div className="dates">June 2016 – August 2020</div>
              </div>
              <div className="responsibilities">
                Led sports activities and mentored children aged 6-12. Developed
                leadership skills, creativity in program planning, and ability
                to engage diverse audiences – directly applicable to fan
                engagement and community outreach roles.
              </div>
            </div>

            <div className="experience-item">
              <div className="job-header">
                <div>
                  <div className="job-title">Kitchen Team Member & Cashier</div>
                  <div className="company">Local Pour & Eatery / Wegmans</div>
                </div>
                <div className="dates">2019 – 2022</div>
              </div>
              <div className="responsibilities">
                Delivered exceptional customer service in high-volume
                environments. Collaborated effectively with diverse teams and
                adapted quickly to changing priorities – skills directly
                transferable to game day operations and event management.
              </div>
            </div>
          </div>

          <div className="section">
            <h2 className="section-title">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z" />
              </svg>
              Education
            </h2>

            <div className="education-item">
              <div className="school">Gannon University</div>
              <div className="degree">Business & Sports Management Studies</div>
              <div className="dates">In progress</div>
            </div>

            <div className="education-item">
              <div className="school">Cathedral Prep High School</div>
              <div className="degree">High School Diploma</div>
              <div className="dates">Class of 2021</div>
            </div>
          </div>

          <div className="section">
            <h2 className="section-title">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
              </svg>
              Core Strengths
            </h2>

            <div className="skills-grid">
              <div className="skill-category">
                <h4>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-label="Communication"
                    style={{ marginRight: "8px" }}
                  >
                    <path d="M4 5h12a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H9l-4 3v-3H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z" />
                  </svg>
                  Marketing & Communication
                </h4>
                <div className="skill-list">
                  <span className="skill-tag">Customer Engagement</span>
                  <span className="skill-tag">Creative Thinking</span>
                  <span className="skill-tag">Social Connection</span>
                  <span className="skill-tag">Brand Messaging</span>
                </div>
              </div>

              <div className="skill-category">
                <h4>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    aria-label="Sports"
                    style={{ marginRight: "8px" }}
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="12" r="9" />
                    <path d="M3 12h18" />
                    <path d="M7.5 4.2a9 9 0 0 1 0 15.6" />
                    <path d="M16.5 4.2a9 9 0 0 0 0 15.6" />
                  </svg>
                  Sports Knowledge
                </h4>
                <div className="skill-list">
                  <span className="skill-tag">Industry Insight</span>
                  <span className="skill-tag">Fan Psychology</span>
                  <span className="skill-tag">Team Dynamics</span>
                  <span className="skill-tag">Sports Analytics</span>
                </div>
              </div>

              <div className="skill-category">
                <h4>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-label="Leadership & Service"
                    style={{ marginRight: "8px" }}
                  >
                    <path d="M7 3h4l1 3h-6l1-3zm6 0h4l1 3h-6l1-3zM12 9a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm-2 10 2-1.2L14 19v3l-2-1.2L10 22v-3z" />
                  </svg>
                  Leadership & Service
                </h4>
                <div className="skill-list">
                  <span className="skill-tag">Team Collaboration</span>
                  <span className="skill-tag">Problem Solving</span>
                  <span className="skill-tag">Youth Mentoring</span>
                  <span className="skill-tag">Adaptability</span>
                </div>
              </div>
            </div>
          </div>

          <div className="cta-section">
            <h3>
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                aria-label="Connection"
                style={{ marginRight: "8px" }}
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M8 12h8" />
                <path d="M7 7h3a4 4 0 0 1 0 8H7a4 4 0 1 1 0-8z" />
                <path d="M14 7h3a4 4 0 1 1 0 8h-3a4 4 0 0 1 0-8z" />
              </svg>
              Ready to Connect
            </h3>
            <p>
              Let's discuss how my passion for sports and natural ability to
              connect with people can contribute to your team's success.
            </p>
            <div className="cta-buttons">
              <a href="mailto:cibble24@gmail.com" className="btn btn-primary">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  style={{ marginRight: "8px" }}
                >
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                </svg>
                Email Me
              </a>
              <a href="tel:8144405829" className="btn btn-secondary">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  style={{ marginRight: "8px" }}
                >
                  <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                </svg>
                Call Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
